/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */

/**
 * Where a booking stands in its lifecycle. Also accepted as a filter on the booking-list
endpoints, where it is matched case-insensitively and several values may be repeated.

 */
export type BookingReferenceDtoStatus = typeof BookingReferenceDtoStatus[keyof typeof BookingReferenceDtoStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BookingReferenceDtoStatus = {
  AWAITING_APPROVAL: 'AWAITING_APPROVAL',
  EXPIRED: 'EXPIRED',
  CANCELED_REMOTE: 'CANCELED_REMOTE',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  CANCELED: 'CANCELED',
  ACTIVE: 'ACTIVE',
  STOPPED: 'STOPPED',
} as const;
